import React from 'react';
import {IconButton, Pane, Spinner} from "evergreen-ui";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import LastPageIcon from "@material-ui/icons/LastPage";

export interface ClientSidePaginationProps {
    page?: number;
    total: number;
    limit: number;
    changePage?: (page: number) => any;
    next?: boolean;
    last?: boolean;
}

export const ClientSidePagination = ({
                                         page = 1,
                                         total,
                                         limit,
                                         changePage = page => console.log(page),
                                     }: ClientSidePaginationProps) => {

    const total_pages = Math.ceil(total / limit);
    page = (page < 1 ? 1 : page > total_pages ? total_pages : page);

    const startCursor = page * limit - limit + 1;
    const endCursor = page * limit > total ? total : page * limit;

    return (
        <Pane display="flex" alignItems="center" className="px-5">
            <div className="pr-5">
                {total_pages != null ? (
                    `${startCursor}-${endCursor} of ${total}`
                ) : (
                    <Spinner size={24}/>
                )}
            </div>

            <IconButton iconBefore={FirstPageIcon}
                        type='button'
                        appearance="minimal"
                        disabled={page <= 1}
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={() => page > 1 ? changePage(1) : {}}
            />
            <IconButton iconBefore={NavigateBeforeIcon}
                        type='button'
                        appearance="minimal" disabled={page === 1 || page > total_pages}
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={() => page > 1 ? changePage(page - 1) : {}}
            />
            <IconButton iconBefore={NavigateNextIcon}
                        type='button'
                        appearance="minimal" disabled={page >= total_pages}
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={() => page < total_pages ? changePage(page + 1) : {}}
            />
            <IconButton iconBefore={LastPageIcon}
                        type='button'
                        appearance="minimal" disabled={page >= total_pages}
                        className="portal-ev-black"
                // @ts-ignore
                        onClick={() => page < total_pages ? changePage(total_pages) : {}}
            />
        </Pane>
    )
}
